package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import kotlinx.coroutines.flow.Flow

class StartInspectionUseCase(
    private val inspectionRepository: InspectionRepository,
) {
    operator fun invoke(
        inspectionId: String,
        templateId: String,
        conductedIso: String
    ): Flow<FlowResult<Unit>> {
        return inspectionRepository.startInspection(
            inspectionId = inspectionId,
            templateId = templateId,
            conductedAtIso = conductedIso
        )
    }
}
